export const formMessages = {
    required: () => 'Required',
    minLength: ({ $params }) => `Minimum ${$params.minLength.min} characters required`,
    maxLength: ({ $params }) => `Maximum allowed ${$params.maxLength.max} characters.`
};
